var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side"},[_c('div',{staticClass:"view"},[_vm._v(_vm._s(_vm.view))]),_c('v-touch',{staticClass:"row",attrs:{"swipe-options":{ threshold: 10 }},on:{"swipeleft":function($event){_vm.direction1
        ? _vm.horizontalSweep('upLeft', 'up', 'anticlockwise')
        : _vm.horizontalSweep('upRight', 'up', 'clockwise')},"swiperight":function($event){_vm.direction1
        ? _vm.horizontalSweep('upRight', 'up', 'clockwise')
        : _vm.horizontalSweep('upLeft', 'up', 'anticlockwise')}}},[_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row1.box1.isRed,
        blue: _vm.grid.row1.box1.isBlue,
        yellow: _vm.grid.row1.box1.isYellow,
        green: _vm.grid.row1.box1.isGreen,
        gray: _vm.grid.row1.box1.isGray,
        pink: _vm.grid.row1.box1.isPink,
      },on:{"swipeup":function($event){_vm.direction
          ? _vm.verticalSweep('leftUp', 'left', 'clockwise')
          : _vm.verticalSweep('leftDown', 'left', 'anticlockwise')},"swipedown":function($event){_vm.direction
          ? _vm.verticalSweep('leftDown', 'left', 'anticlockwise')
          : _vm.verticalSweep('leftUp', 'left', 'clockwise')}}}),_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row1.box2.isRed,
        blue: _vm.grid.row1.box2.isBlue,
        yellow: _vm.grid.row1.box2.isYellow,
        green: _vm.grid.row1.box2.isGreen,
        gray: _vm.grid.row1.box2.isGray,
        pink: _vm.grid.row1.box2.isPink,
      },on:{"swipeup":function($event){_vm.direction ? _vm.verticalSweep('midUp') : _vm.verticalSweep('midDown')},"swipedown":function($event){_vm.direction ? _vm.verticalSweep('midDown') : _vm.verticalSweep('midUp')}}}),_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row1.box3.isRed,
        blue: _vm.grid.row1.box3.isBlue,
        yellow: _vm.grid.row1.box3.isYellow,
        green: _vm.grid.row1.box3.isGreen,
        gray: _vm.grid.row1.box3.isGray,
        pink: _vm.grid.row1.box3.isPink,
      },on:{"swipeup":function($event){_vm.direction
          ? _vm.verticalSweep('rightUp', 'right', 'anticlockwise')
          : _vm.verticalSweep('rightDown', 'right', 'clockwise')},"swipedown":function($event){_vm.direction
          ? _vm.verticalSweep('rightDown', 'right', 'clockwise')
          : _vm.verticalSweep('rightUp', 'right', 'anticlockwise')}}})],1),_c('v-touch',{staticClass:"row",on:{"swipeleft":function($event){_vm.direction1 ? _vm.horizontalSweep('midLeft') : _vm.horizontalSweep('midRight')},"swiperight":function($event){_vm.direction1 ? _vm.horizontalSweep('midRight') : _vm.horizontalSweep('midLeft')}}},[_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row2.box1.isRed,
        blue: _vm.grid.row2.box1.isBlue,
        yellow: _vm.grid.row2.box1.isYellow,
        green: _vm.grid.row2.box1.isGreen,
        gray: _vm.grid.row2.box1.isGray,
        pink: _vm.grid.row2.box1.isPink,
      },on:{"swipeup":function($event){_vm.direction
          ? _vm.verticalSweep('leftUp', 'left', 'clockwise')
          : _vm.verticalSweep('leftDown', 'left', 'anticlockwise')},"swipedown":function($event){_vm.direction
          ? _vm.verticalSweep('leftDown', 'left', 'anticlockwise')
          : _vm.verticalSweep('leftUp', 'left', 'clockwise')}}}),_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row2.box2.isRed,
        blue: _vm.grid.row2.box2.isBlue,
        yellow: _vm.grid.row2.box2.isYellow,
        green: _vm.grid.row2.box2.isGreen,
        gray: _vm.grid.row2.box2.isGray,
        pink: _vm.grid.row2.box2.isPink,
      },on:{"swipeup":function($event){_vm.direction ? _vm.verticalSweep('midUp') : _vm.verticalSweep('midDown')},"swipedown":function($event){_vm.direction ? _vm.verticalSweep('midDown') : _vm.verticalSweep('midUp')}}}),_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row2.box3.isRed,
        blue: _vm.grid.row2.box3.isBlue,
        yellow: _vm.grid.row2.box3.isYellow,
        green: _vm.grid.row2.box3.isGreen,
        gray: _vm.grid.row2.box3.isGray,
        pink: _vm.grid.row2.box3.isPink,
      },on:{"swipeup":function($event){_vm.direction
          ? _vm.verticalSweep('rightUp', 'right', 'anticlockwise')
          : _vm.verticalSweep('rightDown', 'right', 'clockwise')},"swipedown":function($event){_vm.direction
          ? _vm.verticalSweep('rightDown', 'right', 'clockwise')
          : _vm.verticalSweep('rightUp', 'right', 'anticlockwise')}}})],1),_c('v-touch',{staticClass:"row",on:{"swipeleft":function($event){_vm.direction1
        ? _vm.horizontalSweep('downLeft', 'down', 'anticlockwise')
        : _vm.horizontalSweep('downRight', 'down', 'clockwise')},"swiperight":function($event){_vm.direction1
        ? _vm.horizontalSweep('downRight', 'down', 'clockwise')
        : _vm.horizontalSweep('downLeft', 'down', 'anticlockwise')}}},[_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row3.box1.isRed,
        blue: _vm.grid.row3.box1.isBlue,
        yellow: _vm.grid.row3.box1.isYellow,
        green: _vm.grid.row3.box1.isGreen,
        gray: _vm.grid.row3.box1.isGray,
        pink: _vm.grid.row3.box1.isPink,
      },on:{"swipeup":function($event){_vm.direction
          ? _vm.verticalSweep('leftUp', 'left', 'clockwise')
          : _vm.verticalSweep('leftDown', 'left', 'anticlockwise')},"swipedown":function($event){_vm.direction
          ? _vm.verticalSweep('leftDown', 'left', 'anticlockwise')
          : _vm.verticalSweep('leftUp', 'left', 'clockwise')}}}),_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row3.box2.isRed,
        blue: _vm.grid.row3.box2.isBlue,
        yellow: _vm.grid.row3.box2.isYellow,
        green: _vm.grid.row3.box2.isGreen,
        gray: _vm.grid.row3.box2.isGray,
        pink: _vm.grid.row3.box2.isPink,
      },on:{"swipeup":function($event){_vm.direction ? _vm.verticalSweep('midUp') : _vm.verticalSweep('midDown')},"swipedown":function($event){_vm.direction ? _vm.verticalSweep('midDown') : _vm.verticalSweep('midUp')}}}),_c('v-touch',{staticClass:"sub-box",class:{
        red: _vm.grid.row3.box3.isRed,
        blue: _vm.grid.row3.box3.isBlue,
        yellow: _vm.grid.row3.box3.isYellow,
        green: _vm.grid.row3.box3.isGreen,
        gray: _vm.grid.row3.box3.isGray,
        pink: _vm.grid.row3.box3.isPink,
      },on:{"swipeup":function($event){_vm.direction
          ? _vm.verticalSweep('rightUp', 'right', 'anticlockwise')
          : _vm.verticalSweep('rightDown', 'right', 'clockwise')},"swipedown":function($event){_vm.direction
          ? _vm.verticalSweep('rightDown', 'right', 'clockwise')
          : _vm.verticalSweep('rightUp', 'right', 'anticlockwise')}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }